const COINS_IN_CURRENCY = 100;

function getPriceByCoins(coins) {
  return (coins / COINS_IN_CURRENCY).toFixed(2);
}

export default getPriceByCoins;
